// extracted by mini-css-extract-plugin
export default {"navbar":"LoginNavbar_navbar__7lfEq","navImg":"LoginNavbar_navImg__mzTCh"};